import { useEffect, useState } from 'react'
import MyDonutChart from '../../component/InventoryUI/Charts/MyDonutChart'
import MyHistogram from '../../component/InventoryUI/Charts/MyHistogram'
import MyLineChart from '../../component/InventoryUI/Charts/MyLineChart'
import MyPieChart from '../../component/InventoryUI/Charts/MyPieChart'
import DashboardStats from '../../features/Inventory/dashboard/DashboardStats'
import fetcher from '../../helper/fetcher'
import { useSnackbar } from '../../context/SnackBarContext'
import moment from 'moment'

export const DashboardCrm = () => {
  const { showError } = useSnackbar()
  const [invoice, setInvoice] = useState([]);
  const [purchage, setPurchage] = useState([]);
  const [direct, setDirect] = useState([]);
  const [inDirect, setInDirect] = useState([]);
  const [startDate, setStartDate] = useState("2025-01-20");
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const fetchData = () => {
    // fetch invoice
    fetcher.get(`/inventory/invoice/total_invoice?startDate=${startDate}&endDate=${endDate}`)
      .then((res) => setInvoice(res.data?.data))
      .catch((error) => showError(error.response?.data?.message || "Some Error Occured"));

    // fetch purchase
    fetcher.get(`/inventory/purchase/total_purchase?startDate=${startDate}&endDate=${endDate}`)
      .then((res) => setPurchage(res.data?.data))
      .catch((error) => showError(error.response?.data?.message || "Some Error Occured"));

    // fetch direct
    fetcher.get(`/inventory/direct_sale/total_directSale?startDate=${startDate}&endDate=${endDate}`)
      .then((res) => setDirect(res.data?.data))
      .catch((error) => showError(error.response?.data?.message || "Some Error Occured"));

    // fetch indirect
    fetcher.get(`/inventory/indirect_sale/total_inDirectSale?startDate=${startDate}&endDate=${endDate}`)
      .then((res) => setInDirect(res.data?.data))
      .catch((error) => showError(error.response?.data?.message || "Some Error Occured"));
  };

  useEffect(() => {
    if (startDate.trim() && endDate.trim()) {
      fetchData();
    }
  }, [startDate, endDate]);

  console.log("startDate ===>>", startDate, endDate)

  return (
    <div className='min-h-screen'>
      <DashboardStats
        invoice={invoice}
        purchage={purchage}
        direct={direct}
        inDirect={inDirect}
      />

      <div className='flex md:flex-row flex-col gap-4 mt-5'>
        <div className='md:flex-[0.4] flex-1'>
          <MyPieChart
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            invoice={invoice}
            endDate={endDate}
          />
        </div>
        <div className='md:flex-[0.6] flex-1'>
          <MyHistogram
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            direct={direct}
            inDirect={inDirect}
            purchage={purchage}
            endDate={endDate}
          />
        </div>
      </div>

      <div className='flex md:flex-row flex-col gap-4 mt-5'>
        <div className='flex-[0.6]'>
          <MyLineChart
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            direct={direct}
            endDate={endDate}
            purchage={purchage}
          />
        </div>
        <div className='flex-[0.4]'>
          <MyDonutChart
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            invoice={invoice}
            endDate={endDate}
          />
        </div>
      </div>
    </div>
  )
}
